import { DiscordContentFrameCommunicationHandler } from '../../../../shared/scripts/discord/DiscordContentFrameCommunicationHandler.ts';
import { DiscordInviteShareHelper } from '../../../../shared/scripts/discord/DiscordInviteShareHelper.ts';
import { DiscordCommand } from '../../../../../shared/DiscordActivityTypes.ts';
import { uiManager } from '../../EntryHomepage.ts';
import { uiGameManager } from '../../../../shared/scripts/EntryShared.ts';
import { Scene } from '../../ui_html/UISceneTypes.ts';
import { Events } from '@discord/embedded-app-sdk';
import { UIAjaxWrapper } from '../../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../../../shared/scripts/network/UIAPIEndpoints.ts';
import { ArrayUtils } from '@colonist/utils';
import { richPresenceDetails, richPresenceStates } from '../utils/RichPresenceText.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { SDKRequestHandler } from './sdk_requests/SDKRequestHandler.ts';
import { StorageWrapper } from '../../../../shared/scripts/StorageWrapper.ts';
import { UINotificationSendHelper } from '../../../../shared/scripts/notifications/UINotificationSendHelper.ts';
import { UIReferralProgramController } from '../../referral/UIReferralProgramController.ts';
export class DiscordContentFrameController {
    get voiceChannelId() {
        return this.contentFrameCommunicationHandler.voiceChannelId;
    }
    get serverProfile() {
        return this.contentFrameCommunicationHandler.serverProfile;
    }
    get inDiscordServer() {
        return this.contentFrameCommunicationHandler.inDiscordServer;
    }
    get canInviteFriends() {
        return this.contentFrameCommunicationHandler.userPermissions.canInviteFriends;
    }
    get referrerId() {
        return this.contentFrameCommunicationHandler.referrerId;
    }
    get referralOrReactivationType() {
        return this.contentFrameCommunicationHandler.referralTypeId;
    }
    get isInitialLoad() {
        return this.contentFrameCommunicationHandler.isInitialLoad;
    }
    async init(loadingScreen) {
        this.loadingScreen = loadingScreen;
        await this.contentFrameCommunicationHandler.waitToBeReady();
        await this.contentFrameCommunicationHandler.sendMessageToMount({
            command: DiscordCommand.SetActivity,
            data: {
                activity: {
                    details: ArrayUtils.randomElementFromArray(richPresenceDetails),
                    type: 0,
                    state: ArrayUtils.randomElementFromArray(richPresenceStates)
                }
            }
        });
        await this.contentFrameCommunicationHandler.sendMessageToMount({
            command: DiscordCommand.SetOrientation,
            data: {
                orientation: UIUtilsEjsVariables.discordActivityMobileOrientation
            }
        });
        let firstRun = true;
        const toggleFloatingWindowMode = Events.ACTIVITY_LAYOUT_MODE_UPDATE;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        void this.contentFrameCommunicationHandler.subscribeToDiscordEvent(toggleFloatingWindowMode, (eventData)=>{
            if (firstRun) {
                firstRun = false;
                return;
            }
            DiscordContentFrameController.toggleFPSIfPipMode(eventData.layout_mode);
            if (eventData.layout_mode) {
                this.loadingScreen.hideSpinner();
                this.loadingScreen.showBackground();
                uiGameManager === null || uiGameManager === void 0 ? void 0 : uiGameManager.gameStore.getState().gameClientConfig.setIsAppInBackground(true);
                return;
            }
            this.loadingScreen.hideBackground();
            this.loadingScreen.showSpinner();
            uiGameManager === null || uiGameManager === void 0 ? void 0 : uiGameManager.gameStore.getState().gameClientConfig.setIsAppInBackground(false);
        });
        const purchaseReceived = Events.ENTITLEMENT_CREATE;
        await this.contentFrameCommunicationHandler.subscribeToDiscordEvent(purchaseReceived, async (data)=>{
            await this.handlePendingPurchases();
        });
        const referrerId = this.referrerId;
        const referralOrReactivationType = this.referralOrReactivationType;
        this.referralController = new UIReferralProgramController(referrerId, referralOrReactivationType);
        await this.referralController.initReferralTracking();
    }
    static toggleFPSIfPipMode(pipMode) {
        var _uiGameManager_canvasController_fps, _uiGameManager_canvasController;
        if (UIUtilsEjsVariables.isProduction) return;
        if (uiManager == undefined) return;
        if (uiManager.sceneController.scene != Scene.Game) return;
        if (((_uiGameManager_canvasController = uiGameManager.canvasController) === null || _uiGameManager_canvasController === void 0 ? void 0 : (_uiGameManager_canvasController_fps = _uiGameManager_canvasController.fps) === null || _uiGameManager_canvasController_fps === void 0 ? void 0 : _uiGameManager_canvasController_fps.div) == undefined) return;
        uiGameManager.canvasController.fps.div.style.display = pipMode ? 'none' : 'block';
    }
    async handlePendingPurchases() {
        await ClientUserState.waitUntilFresh;
        var _StorageWrapper_getGiftMetadataId;
        const giftMetadataId = (_StorageWrapper_getGiftMetadataId = StorageWrapper.getGiftMetadataId()) !== null && _StorageWrapper_getGiftMetadataId !== void 0 ? _StorageWrapper_getGiftMetadataId : undefined;
        const response = await UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiHandleDiscordPurchase(), undefined, {
            accessToken: this.contentFrameCommunicationHandler.userDiscordAccessToken,
            giftMetadataId: giftMetadataId
        });
        if (response == undefined) return;
        const purchaseSuccess = response.json;
        if (!purchaseSuccess) return;
        StorageWrapper.clearGiftMetadataId();
        await ClientUserState.refresh();
        UINotificationSendHelper.getNotifications();
        if (uiManager.sceneController.scene == Scene.DiscordGifting) uiManager.sceneController.loadScene(Scene.DiscordStore);
    }
    sendSDKRequest(sdkRequest, data) {
        this.sdkRequestHandler.processSDKRequest(sdkRequest, data);
    }
    inviteFriendsToRoom(roomId) {
        DiscordInviteShareHelper.inviteFriendsToRoom(this.contentFrameCommunicationHandler, {
            inDiscordServer: this.inDiscordServer,
            canInviteFriends: this.canInviteFriends,
            roomId: roomId
        });
    }
    shareStoreReferral(referralReward) {
        DiscordInviteShareHelper.shareStoreReferral(this.contentFrameCommunicationHandler, referralReward);
    }
    constructor(){
        this.contentFrameCommunicationHandler = new DiscordContentFrameCommunicationHandler();
        this.sdkRequestHandler = new SDKRequestHandler(this.contentFrameCommunicationHandler);
    }
}
